import { GetStaticProps } from "next";
import { QuestionnaireCphLayout } from "layouts/pages/QuestionnaireCphLayout";

import { serverSideTranslations } from "utils/next/translations";
import { checkIsNotFound } from "configs/unsupport-locale-routes";
import { UrlsConfig } from "configs/urlsConfig";
import { Theme } from "constants/enum";

export default function QuestionFormCph() {
    return <QuestionnaireCphLayout />;
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    if (checkIsNotFound(UrlsConfig.TYPEFORM_CPH, locale)) {
        return {
            notFound: true,
        };
    }

    return {
        props: {
            ...(await serverSideTranslations(locale, ["global"])),
            withHeader: false,
            withFooter: false,
            key: locale,
            themeType: Theme.SYT,
            withMessengerWidget: false,
        },
    };
};
